(function ($) {
// Backbone View for edit group form
    TestimonialForm = Backbone.View.extend({
        bindings: function () { // bindings for input fields
            var result = {};
            var cf = 'custom_fields.';

            result['[name="testimonial_name"]']             = 'name';
            result['[name="testimonial_category"]']         = 'category';
            result['[name="testimonial_short_text"]']       = 'short_text';
            result['[name="testimonial_full_text"]']        = 'full_text';

            result['[name="testimonial_position"]']         = cf + 'position';
            result['[name="testimonial_source_name"]']      = cf + 'source_name';
            result['[name="testimonial_source_url"]']       = cf + 'source_url';
            result['[name="testimonial_thumbnail_id"]']     = cf + 'thumbnail_id';
            result['[name="testimonial_custom_url"]']       = cf + 'custom_url';

            result['[name="testimonial_email"]']            = cf + 'email';
            result['[name="testimonial_phone"]']            = cf + 'phone';
            result['[name="testimonial_skype"]']            = cf + 'skype';
            result['[name="testimonial_location"]']         = cf + 'location';
            result['[name="testimonial_facebook"]']         = cf + 'facebook';
            result['[name="testimonial_twitter"]']          = cf + 'twitter';
            result['[name="testimonial_linkedin"]']         = cf + 'linkedin';
            result['[name="testimonial_google"]']           = cf + 'google';
            result['[name="testimonial_instagram"]']        = cf + 'instagram';
            result['[name="testimonial_pinterest"]']        = cf + 'pinterest';
            result['[name="testimonial_youtube"]']          = cf + 'youtube';
            result['[name="testimonial_vimeo"]']            = cf + 'vimeo';
            result['[name="testimonial_dribble"]']          = cf + 'dribble';
            result['[name="testimonial_flickr"]']           = cf + 'flickr';
            result['[name="testimonial_github"]']           = cf + 'github';

            result[':el'] = {
                observe: 'id',
                update: function ($el, val, model, options) {
                    $el.attr('testimonial-id', val);
                }
            }

            result['.testimonial_rating'] = {
                observe: [
                    cf + 'created_from'
                ],
                update: function ($el, val, model, options) {
                    $el.find('.hint.hint-inside').remove();
                    if(val == 'form'){
                        $el.html('<span class="form-control"></span>');
                        $el.parents('.form-group').after('<p class="hint hint-inside">This testimonial is published from submission form, you can\'t edit rating.</p>')
                    }else{

                        $el.html('<input type="text" class="form-control" name="testimonial_rating" placeholder="From 0 to 100"/>');
                    }
                }
            }

            result['.testimonial_rating span.form-control'] = {
                observe: cf + 'rating',
                update: function ($el, val, model, options) {
                    $el.html(val);
                }
            }

            result['.testimonial_rating [name="testimonial_rating"]'] = {
                observe: cf + 'rating',
                events: ['input'],
                onGet: function (val, options) {
                    var value = val ? val.replace(/\D+/g, '') : '';
                    value = parseInt(value) > 100 ? 100 : value;
                    return value;
                },
                update: function ($el, val, model, options) {
                    $el.val(val);
                }
            }

            result['#form-hint'] = {
                observe: 'post_status',
                update: function($el, val, model, options){
                    if(val == 'pending') {
                        $el.html('<p class="hint alert-warning">FYI: this testimonial still NOT published and would not be visible on site. You can publish it with one click.</p>');
                    }else{
                        $el.html('');
                    }
                }
            }

            result['[data-action="publish-testimonial"]'] = {
                observe: 'post_status',
                update: function($el, val, model, options){
                    if(val == 'pending') {
                        $el.show();
                    }else{
                        $el.hide();
                    }
                }
            }

            result['.testimonial-rating-formats'] = {
                observe: cf + 'rating',
                update: function ($el, val, model, options) {
                    if(!$.isNumeric(val)){
                        return;
                    }
                    var five = val / 20 + '/5';
                    var ten = val / 10 + '/10';
                    $el.find('.5s .rating-fill').css('width', val + '%');
                    $el.find('.5d').html(five);
                    $el.find('.10d').html(ten);
                }
            };

            result['[name="testimonial_rating"]'] = {
                observe: [cf + 'rating'],
                onGet: function (val, options) {
                    var value = '' + val[0];
                    value = value.replace(/\D+/g, '');
                    value = parseInt(value) > 100 ? 100 : value;
                    return value;
                }
            };
            result['[name="testimonial_rating_label"]']     = cf + 'rating_label';

            return result;
        },
        render: function () {
            this.stickit();
            return this;
        }
    });
})(jQuery);
